import { all, put, call, takeEvery } from 'redux-saga/effects'
import onlineSalesProcessService from './onlineSalesProcess.services'
import { SET_ERROR, SET_LOADING } from './onlineSalesProcess.actions'
import onlineSalesProcessActions from './onlineSalesProcess.types'

export function* HANDLE_STATE({ field, value }) {
  yield put({
    type: onlineSalesProcessActions.SET_STATE,
    payload: {
      [field]: value,
    },
  })
}

export function* HANDLE_CONTENT({ payload }) {
  yield put({
    type: onlineSalesProcessActions.SET_STATE,
    payload: {
      contentStatus: payload,
    },
  })
}

export function* GET_DATA_ONLINE_SALES_PARTY_AVAILABILITY_LIST({ payload }) {
  yield call(SET_LOADING, true)
  try {
    yield put(onlineSalesProcessService.getAllDatas(payload))
  } catch (e) {
    yield call(SET_ERROR, e)
  }
}


export default function* rootSaga() {
  yield all([
    takeEvery(onlineSalesProcessActions.HANDLE_STATE, HANDLE_STATE),
    takeEvery(onlineSalesProcessActions.GET_DATA_ONLINE_SALES_PARTY_AVAILABILITY_LIST,GET_DATA_ONLINE_SALES_PARTY_AVAILABILITY_LIST)
  ])
}
